import classNames from 'classnames/bind';
import React from 'react';

import styles from './common.module.scss';

import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  return (
    <div className={cx('container')}>
      <label>
        Servo Instance Number
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.servo} readOnly />
        </div>
      </label>
      <label>
        Pulse Width Modulation
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.pwm} readOnly />
        </div>
      </label>
    </div>
  );
};

export default Item;
